import * as React from "react";
import styled from "@mui/material/styles/styled";
import { Button, ButtonProps } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { AgentTooltip } from "fe-common/ui/AgentTooltip";

//region [[ Styles ]]

const MainButtonView = styled(Button)((props: any) => ({
  color: "white",
  backgroundColor: KahunColorMap.Primary,
  display: "flex",
  alignItems: "center",
  fontWeight: 500,
  boxShadow: "unset",
  width: "100%",
  height: "46px",
  fontSize: "17px",
  borderRadius: "56px",
  whiteSpace: "nowrap",
  textTransform: "none",
  "&:hover": {},
}));

const ActionIcon = styled("div")(({ theme }) => ({
  color: KahunColorMap.Primary,
  display: "flex",
  alignItems: "center",
  margin: "0 4px",
}));

const ActionIconContainer = styled("div")(({ theme }) => ({
  cursor: "pointer",
  marginRight: "20px",
  [theme.breakpoints.down("sm")]: {
    filter: "brightness(0) invert(1)",
    marginRight: "0px",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface MainButtonProps extends ButtonProps {
  icon?: any;
  label: string;
  fullWidth?: boolean;
  primary?: string;
  className?: string;
  iconOnly?: boolean;
  onClick?: (event) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

/***
 * A Common action button in the Kahun agent
 * @see
 * @param className
 * @param primary
 * @param onClick
 * @param fullWidth
 * @param icon
 * @param label
 * @param props
 * @constructor
 */
export const MainButton = ({
  className,
  primary = "false",
  onClick,
  fullWidth,
  icon,
  label,
  iconOnly,
  ...props
}: MainButtonProps) => {
  return (
    <>
      {iconOnly ? (
        <AgentTooltip title={label}>
          <ActionIconContainer onClick={onClick}>
            <ActionIcon>{icon}</ActionIcon>
          </ActionIconContainer>
        </AgentTooltip>
      ) : (
        <MainButtonView
          className={className}
          variant={primary === "true" ? "contained" : "outlined"}
          onClick={onClick}
          fullWidth={fullWidth}
          primary={primary}
          {...props}
        >
          {icon && <ActionIcon>{icon}</ActionIcon>} {label}
        </MainButtonView>
      )}
    </>
  );
};
